// extracted by mini-css-extract-plugin
module.exports = {"marqueeCon":"LogoMarquee_marqueeCon__V9YXY","marquee":"LogoMarquee_marquee__IdJ2B","rotateMe":"LogoMarquee_rotateMe__FpsDZ"};